import React from 'react';
import { ModalBanner } from 'snacks-design-system';

interface componentProps {
  children: React.ReactNode;
}

const PIEModalBanner = (props: componentProps) => {
  return <ModalBanner {...props} />;
};

export default PIEModalBanner;
